import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";

export const createReservation = createAsyncThunk(
  "reservation/createReservation",
  async ({ telegramId, reservationData }, { rejectWithValue }) => {
    try {
      const initData = window.Telegram.WebApp.initData;

      const response = await axios.post(
        `/api/createReservation/${telegramId}/reservation`,
        reservationData,
        {
          headers: {
            "X-Telegram-Init-Data": initData
          }
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || null);
    }
  }
);

export const createSpecialOffer = createAsyncThunk(
  "reservation/createSpecialOffer",
  async ({ telegramId, offerData }) => {
    const initData = window.Telegram.WebApp.initData;

    const response = await axios.post(
      `/api/specialoffer/${telegramId}/special-offer`,
      offerData,
      {
        headers: {
          "X-Telegram-Init-Data": initData
        }
      }
    );

    return response.data;
  }
);

const reservationSlice = createSlice({
  name: "reservation",
  initialState: {
    loading: false,
    success: false,
    error: null,
    special: {
      loading: false,
      success: false,
      error: null,
    },
  },
  reducers: {
    resetSuccess(state) {
      state.success = false;
    },
    resetError(state) {
      state.error = null;
    },
    resetSpecialSuccess(state) {
      state.special.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createReservation.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createReservation.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createReservation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload != null ? action.payload : true;
      })
      .addCase(createSpecialOffer.pending, (state) => {
        state.special.loading = true;
        state.special.error = null;
        state.special.success = false;
      })
      .addCase(createSpecialOffer.fulfilled, (state) => {
        state.special.loading = false;
        state.special.success = true;
      })
      .addCase(createSpecialOffer.rejected, (state, action) => {
        state.special.loading = false;
        state.special.error = action.error.message;
      });
  },
});

export const { resetSuccess, resetError, resetSpecialSuccess } = reservationSlice.actions;
export default reservationSlice.reducer;
